export enum EDropshippingProvider {
  SHOPIFY = 'SHOPIFY',
  NUVEM_SHOP = 'NUVEM_SHOP',
  CART_PANDA = 'CART_PANDA',
  MERCADO_LIVRE = 'MERCADO_LIVRE',
  YAMPI = 'YAMPI',
  WOO_COMMERCE = 'WOO_COMMERCE',
  LPQV = 'LPQV',
}
